import { useEffect, useState } from 'react';

export const DynamicStyles = ({ colors }) => {
  const [currentColors, setCurrentColors] = useState(colors);

  useEffect(() => {
    setCurrentColors(colors);
  }, [colors]);

  useEffect(() => {
    // Listen for theme updates
    const handleThemeUpdate = (event) => {
      setCurrentColors(event.detail);
    };

    window.addEventListener('themeUpdate', handleThemeUpdate);
    return () => window.removeEventListener('themeUpdate', handleThemeUpdate);
  }, []);

  useEffect(() => {
    if (!currentColors) return;

    // Create or update the style element
    let styleEl = document.getElementById('dynamic-theme-styles');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'dynamic-theme-styles';
      document.head.appendChild(styleEl);
    }

    // Generate dynamic CSS
    const css = `
      /* Override Tailwind classes with dynamic colors */
      .bg-sage-700 {
        background-color: ${currentColors.primary} !important;
      }
      .bg-sage-800 {
        background-color: ${currentColors.primary} !important;
        filter: brightness(0.9);
      }
      .bg-sage-50 {
        background-color: ${currentColors.background} !important;
      }
      .bg-sage-100 {
        background-color: ${currentColors.primary}15 !important;
      }
      .text-sage-700,
      .text-sage-800 {
        color: ${currentColors.primary} !important;
      }
      .border-sage-700,
      .border-sage-300,
      .border-sage-200 {
        border-color: ${currentColors.primary}50 !important;
      }
      .hover\\:bg-sage-800:hover {
        background-color: ${currentColors.primary} !important;
        filter: brightness(0.85);
      }
      .hover\\:bg-sage-50:hover {
        background-color: ${currentColors.background} !important;
      }
      .hover\\:text-sage-800:hover {
        color: ${currentColors.primary} !important;
      }
      .bg-lavender-100 {
        background-color: ${currentColors.secondary}25 !important;
      }
      .text-lavender-700 {
        color: ${currentColors.secondary} !important;
      }
      .bg-rose-100 {
        background-color: ${currentColors.accent}25 !important;
      }
      .text-rose-700 {
        color: ${currentColors.accent} !important;
      }
      .bg-amber-100 {
        background-color: ${currentColors.accent}25 !important;
      }
      .text-amber-700 {
        color: ${currentColors.accent} !important;
      }
      .bg-gradient-to-br.from-sage-700 {
        background: linear-gradient(to bottom right, ${currentColors.primary}, ${currentColors.primary}) !important;
        filter: brightness(0.95);
      }
      .from-sage-50 {
        --tw-gradient-from: ${currentColors.background} !important;
      }
      .via-lavender-50 {
        --tw-gradient-via: ${currentColors.secondary}10 !important;
      }
      .to-cream-50 {
        --tw-gradient-to: ${currentColors.background} !important;
      }
      .bg-sage-900 {
        background-color: ${currentColors.primary} !important;
        filter: brightness(0.5);
      }
      .border-sage-800 {
        border-color: ${currentColors.primary}80 !important;
      }
      .text-sage-200,
      .text-sage-300 {
        color: ${currentColors.background} !important;
        opacity: 0.8;
      }
      .hover\\:border-sage-400:hover {
        border-color: ${currentColors.primary}60 !important;
      }
      .border-sage-600 {
        border-color: ${currentColors.primary} !important;
      }
      .hover\\:border-sage-300:hover {
        border-color: ${currentColors.primary}40 !important;
      }
      .bg-lavender-50 {
        background-color: ${currentColors.secondary}10 !important;
      }
      .from-sage-700 {
        --tw-gradient-from: ${currentColors.primary} !important;
      }
      .to-sage-800 {
        --tw-gradient-to: ${currentColors.primary} !important;
      }
    `;

    styleEl.textContent = css;
  }, [currentColors]);

  return null; // This component doesn't render anything
};
